import CheckboxInput from 'components/input/CheckboxInput';
import GroupRadioButton from 'components/input/GroupRadioButton';
import SelectInput from 'components/input/SelectInput';
import TextInput from 'components/input/textInput';
import YesNoSwitch from 'components/input/YesNoSwitch';
import { Row, Col, Card } from 'react-bootstrap';
import GroupCheckbox from 'components/input/GroupCheckbox';
import {
  asianOptions,
  TribalEnrollmentCategoryOptions,
  TribalEnrollmentPrimaryOptions1,
  TribalEnrollmentPrimaryOptions2,
  TribalEnrollmentPrimaryOptions3,
} from './components/constantDemographic';
import { tribalEnrollmentOptions } from 'components/helper/helper';

interface Props {
  formik: any;
  check: any;
  isMobile?: boolean;
  disabled?: boolean;
}

export const nativeHawaiianOptions = [
  {
    value: 'best_group_describe_racial_background_array.racial_background_Carolinian',
    label: 'Carolinian',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Chuukese',
    label: 'Chuukese',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Fijian',
    label: 'Fijian',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Guam',
    label: 'Guamanian / Chamorro',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_IKiribati',
    label: 'I-Kiribati',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Kosraean',
    label: 'Kosraean',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_MarianaIslander',
    label: 'Mariana Islander',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Marshallese',
    label: 'Marshallese',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Hawaii',
    label: 'Native Hawaiian',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_NiVanuatu',
    label: 'Ni-Vanuatu',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Palauan',
    label: 'Palauan',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_PapuaNewGuinean',
    label: 'Papua New Guinean',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Pohnpeian',
    label: 'Pohnpeian',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Saipanese',
    label: 'Saipanese',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Samoa',
    label: 'Samoan',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_SolomonIslander',
    label: 'Solomon Islander',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Tahitian',
    label: 'Tahitian',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Tokelauan',
    label: 'Tokelauan',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Tongan',
    label: 'Tongan',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_Yapese',
    label: 'Yapese',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_OtherMelanesian',
    label: 'Other Melanesian',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_OtherMicronesian',
    label: 'Other Micronesian',
  },
  {
    value: 'best_group_describe_racial_background_array.racial_background_OtherPacific',
    label: 'Other Pacific Islander',
  },

  {
    value: 'best_group_describe_racial_background_array.racial_background_OtherPolynesian',
    label: 'Other Polynesian',
  },
];

export const swAsianAndNorthAfricanOptions = [
  {
    key: 'best_group_describe_racial_background_array.racial_background_EuropeanDescent',
    value: 'European',
  },
  {
    key: 'best_group_describe_racial_background_array.racial_background_OtherWhite',
    value: 'Other White',
  },
];
export const backgroundDescribeOption = [
  { id: 'best_group_describe_racial_background_array.is_Argentinean', value: 'Argentinean' },
  { id: 'best_group_describe_racial_background_array.is_Bolivian', value: 'Bolivian' },
  { id: 'best_group_describe_racial_background_array.is_Chilean', value: 'Chilean' },
  { id: 'best_group_describe_racial_background_array.is_CostaRican', value: 'Costa Rican' },
  { id: 'best_group_describe_racial_background_array.is_Colombian', value: 'Colombian' },
  { id: 'best_group_describe_racial_background_array.is_Cuban', value: 'Cuban' },
  { id: 'best_group_describe_racial_background_array.is_Dominican', value: 'Dominican (Republic)' },
  { id: 'best_group_describe_racial_background_array.is_Ecuadorian', value: 'Ecuadorian' },
  { id: 'best_group_describe_racial_background_array.is_Guatemalan', value: 'Guatemalan' },
  { id: 'best_group_describe_racial_background_array.is_Honduran', value: 'Honduran' },
  { id: 'best_group_describe_racial_background_array.is_Mexican', value: 'Mexican' },
  { id: 'best_group_describe_racial_background_array.is_Nicaraguan', value: 'Nicaraguan' },
  { id: 'best_group_describe_racial_background_array.is_Panamanian', value: 'Panamanian' },
  { id: 'best_group_describe_racial_background_array.is_Paraguayan', value: 'Paraguayan' },
  { id: 'best_group_describe_racial_background_array.is_Peruvian', value: 'Peruvian' },
  { id: 'best_group_describe_racial_background_array.is_Puerto', value: 'Puerto Rican' },
  { id: 'best_group_describe_racial_background_array.is_Salvadoran', value: 'Salvadoran' },
  { id: 'best_group_describe_racial_background_array.is_Spaniard', value: 'Spaniard' },
  { id: 'best_group_describe_racial_background_array.is_Uruguayan', value: 'Uruguayan' },
  { id: 'best_group_describe_racial_background_array.is_Venezuelan', value: 'Venezuelan' },
  {
    id: 'best_group_describe_racial_background_array.is_Other_Central_American',
    value: 'Other Central American',
  },
  {
    id: 'best_group_describe_racial_background_array.is_Other_South_American',
    value: 'Other South American',
  },
  {
    id: 'best_group_describe_racial_background_array.is_Other_Hispanic_or_Latino',
    value: 'Other Hispanic or Latino',
  },
];
const Ethnicity = (props: Props) => {
  const { isMobile = false, disabled = false } = props;
  const { check, formik } = props;

  return (
    <Row className="m-0">
      <div className="fs-5 p-1" style={{ marginLeft: '-4px' }}>
        Ethnicity
      </div>
      <div className="text-field-light">
        To help us understand the diverse racial and ethnic backgrounds of our students, please tell
        us which of the following groups best describes your background. Select all categories that
        apply to you
      </div>
      <div
        className="my-1 mt-3  uc-flag"
        style={{
          backgroundColor:
            (props.formik.values.is_consider_hispanic_latino === '' ||
              props.formik.values.is_consider_hispanic_latino === null) &&
            check
              ? '#FFEBEB'
              : '',
          display: 'inline-block',
        }}
      >
        Do you consider yourself Hispanic or Latino?*
      </div>

      <YesNoSwitch
        className="my-3"
        name={'is_consider_hispanic_latino'}
        values={props.formik.values.is_consider_hispanic_latino}
        onChange={props.formik.handleChange}
        label="Includes persons of Cuban, Mexican, Puerto Rican, South or Central American or other Spanish culture or origin."
        disabled={disabled}
      />

      {props.formik.values.is_consider_hispanic_latino === 'true' && (
        <>
          <GroupRadioButton
            columns={4}
            label="Which best describes your Hispanic or Latino background?"
            logo="span-csu-logo"
            name={'best_group_describe_racial_background_array.value_consider_hispanic_latino'}
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.value_consider_hispanic_latino
            }
            onChange={props.formik.handleChange}
            disabled={disabled}
            options={backgroundDescribeOption.map((i) => i.value)}
            isMissing={
              !props.formik.values.best_group_describe_racial_background_array
                ?.value_consider_hispanic_latino && check
                ? true
                : false
            }
          />
          <TextInput
            className="px-3"
            logo="span-csu-logo"
            hidden={
              props.formik.values.best_group_describe_racial_background_array
                .value_consider_hispanic_latino !== 'Other Central American'
            }
            mdCol={'12'}
            label={'Please specify Other Central American:*'}
            name={'best_group_describe_racial_background_array.specify_is_Other_Central_American'}
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.specify_is_Other_Central_American
            }
            onChange={props.formik.handleChange}
            disabled={disabled}
            countText={50}
            isMissing={
              !props.formik.values.best_group_describe_racial_background_array
                ?.specify_is_Other_Central_American && check
                ? true
                : false
            }
          />
          <TextInput
            className="px-3"
            logo="span-csu-logo"
            hidden={
              props.formik.values.best_group_describe_racial_background_array
                .value_consider_hispanic_latino !== 'Other South American'
            }
            mdCol={'12'}
            label={'Please specify Other South American:'}
            name={'best_group_describe_racial_background_array.specify_is_Other_South_American'}
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.specify_is_Other_South_American
            }
            disabled={disabled}
            isMissing={
              !props.formik.values.best_group_describe_racial_background_array
                ?.specify_is_Other_South_American && check
                ? true
                : false
            }
            onChange={props.formik.handleChange}
            countText={50}
          />
          <TextInput
            className="px-3"
            logo="span-csu-logo"
            hidden={
              props.formik.values.best_group_describe_racial_background_array
                .value_consider_hispanic_latino !== 'Other Hispanic or Latino'
            }
            mdCol={'12'}
            label={'Please specify Other Hispanic or Latino:'}
            name={'best_group_describe_racial_background_array.specify_is_Other_Hispanic_or_Latino'}
            isMissing={
              !props.formik.values.best_group_describe_racial_background_array
                ?.specify_is_Other_Hispanic_or_Latino && check
                ? true
                : false
            }
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.specify_is_Other_Hispanic_or_Latino
            }
            onChange={props.formik.handleChange}
            disabled={disabled}
            countText={50}
          />
        </>
      )}

      <GroupCheckbox
        label="Regardless of your answer to the prior question, please indicate how you identify yourself.*"
        logo="span-csu-logo"
        form={props.formik}
        className="my-3"
        columns={2}
        options={[
          {
            mdCol: 6,
            value:
              'best_group_describe_racial_background_array.racial_background_identify_AfricanAmerican',
            label: 'Black or African American',
            disabled: disabled,
          },
          {
            mdCol: 6,
            value: 'best_group_describe_racial_background_array.racial_background_identify_White',
            label: 'White',
            disabled: disabled,
          },
          {
            mdCol: 6,
            value: 'best_group_describe_racial_background_array.racial_background_identify_Asian',
            label: 'Asian',
            disabled: disabled,
          },
          {
            mdCol: 6,
            value:
              'best_group_describe_racial_background_array.racial_background_identify_Southwest_Asian_and_North_African',
            label: 'Southwest Asian and North African',
            disabled: disabled,
          },
          {
            mdCol: 6,
            value:
              'best_group_describe_racial_background_array.racial_background_identify_NativeHawaiian',
            label: 'Native Hawaiian or Other Pacific Islander',
            disabled: disabled,
          },
          {
            mdCol: 6,
            value:
              'best_group_describe_racial_background_array.racial_background_identify_AmericanIndian',
            label: 'American Indian or Alaska Native',
            disabled: disabled,
          },
        ]}
        isMissing={
          !props.formik.values?.best_group_describe_racial_background_array
            ?.racial_background_identify_AfricanAmerican &&
          !props.formik.values?.best_group_describe_racial_background_array
            ?.racial_background_identify_White &&
          !props.formik.values?.best_group_describe_racial_background_array
            ?.racial_background_identify_Asian &&
          !props.formik.values?.best_group_describe_racial_background_array
            ?.racial_background_identify_Southwest_Asian_and_North_African &&
          !props.formik.values?.best_group_describe_racial_background_array
            ?.racial_background_identify_NativeHawaiian &&
          !props.formik.values?.best_group_describe_racial_background_array
            ?.racial_background_identify_AmericanIndian &&
          check
        }
      />

      {/* If American Indian or Alaska Native then show following content */}
      {props.formik.values.best_group_describe_racial_background_array
        ?.racial_background_identify_AmericanIndian && (
        <Card className="my-3 bg-white p-3">
          <YesNoSwitch
            label="Are you an enrolled member of an American Indian or Alaska Native tribe (U.S.)?*"
            name="best_group_describe_racial_background_array.is_enrolled_member_of_American_Indian_or_Alaska_Native"
            onChange={props.formik.handleChange}
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.is_enrolled_member_of_American_Indian_or_Alaska_Native
            }
            disabled={disabled}
            isMissing={
              !props.formik.values.best_group_describe_racial_background_array
                ?.is_enrolled_member_of_American_Indian_or_Alaska_Native && check
                ? true
                : false
            }
            onClear={() => {
              props.formik.setFieldValue('best_group_describe_racial_background_array', {
                ...props.formik.values.best_group_describe_racial_background_array,
                is_enrolled_member_of_American_Indian_or_Alaska_Native: '',
              });
            }}
          />
          {props.formik.values.best_group_describe_racial_background_array
            ?.is_enrolled_member_of_American_Indian_or_Alaska_Native === 'true' && (
            <>
              <GroupRadioButton
                className="my-3"
                columns={ isMobile ? 2 : 1 }
                mdCol={ isMobile ? 6 : 12 }
                label="Please select the category that best reflects your tribal enrollment. If you are an enrolled member of more than one tribe, select your primary tribal affiliation from the list of recognized tribes.*"
                options={TribalEnrollmentCategoryOptions}
                name="best_group_describe_racial_background_array.tribal_enrollment_category"
                onChange={(e: any) => {
                  let arr: any = Object.assign(
                    {},
                    props.formik.values.best_group_describe_racial_background_array
                  );
                  arr.tribal_enrollment_primary = '';
                  formik.setFieldValue(`best_group_describe_racial_background_array`, arr);

                  //Reset value to empty if value not in TribalEnrollmentCategoryOptionsx
                  switch (e.target.value) {
                    case TribalEnrollmentCategoryOptions[0]:
                      if (
                        !TribalEnrollmentPrimaryOptions1.includes(
                          `${
                            props.formik.values.best_group_describe_racial_background_array
                              ?.tribal_enrollment_category ?? ''
                          }`
                        )
                      ) {
                        formik.setFieldValue(`best_group_describe_racial_background_array`, arr);
                      }
                      break;
                    case TribalEnrollmentCategoryOptions[1]:
                      if (
                        !TribalEnrollmentPrimaryOptions2.includes(
                          `${
                            props.formik.values.best_group_describe_racial_background_array
                              ?.tribal_enrollment_category ?? ''
                          }`
                        )
                      ) {
                        formik.setFieldValue(`best_group_describe_racial_background_array`, arr);
                      }
                      break;
                    case TribalEnrollmentCategoryOptions[2]:
                      if (
                        !TribalEnrollmentPrimaryOptions3.includes(
                          `${
                            props.formik.values.best_group_describe_racial_background_array
                              ?.tribal_enrollment_category ?? ''
                          }`
                        )
                      ) {
                        formik.setFieldValue(`best_group_describe_racial_background_array`, arr);
                      }
                      break;
                  }
                  props.formik.handleChange(e);
                }}
                values={
                  props.formik.values.best_group_describe_racial_background_array
                    ?.tribal_enrollment_category
                }
                disabled={disabled}
                isMissing={
                  !props.formik.values.best_group_describe_racial_background_array
                    ?.tribal_enrollment_category && check
                    ? true
                    : false
                }
              />
              <div className="my-3">
                <TextInput
                  label="Please enter the name of the tribe that is your primary affiliation"
                  name="best_group_describe_racial_background_array.tribal_enrollment_primary"
                  onChange={props.formik.handleChange}
                  values={
                    props.formik.values.best_group_describe_racial_background_array
                      ?.tribal_enrollment_primary
                  }
                  disabled={disabled}
                  countText={300}
                />
              </div>
              {props.formik.values.best_group_describe_racial_background_array
                .tribal_enrollment_category === TribalEnrollmentCategoryOptions[0] && (
                <>
                  <div className="my-3">
                    <TextInput
                      name="best_group_describe_racial_background_array.tribal_citizenship_or_enrollment_number"
                      onChange={props.formik.handleChange}
                      values={
                        props.formik.values.best_group_describe_racial_background_array
                          ?.tribal_citizenship_or_enrollment_number
                      }
                      label="Please provide your tribal citizenship or enrollment number."
                      disabled={disabled}
                      countText={20}
                    />
                  </div>
                  <div className="text-mute my-3">
                    Your enrollment in an American Indian or Alaska Native tribe may be considered
                    during the comprehensive review of your UC application for admission.
                  </div>
                  <CheckboxInput
                    className="my-3"
                    name="best_group_describe_racial_background_array.is_consent_to_the_use_of_tribal_citizenship_or_enrollment_information"
                    label="I consent to the use of my tribal citizenship and enrollment status for purposes concerning my UC application for admission. I understand that this information is subject to verification."
                    values={
                      props.formik.values.best_group_describe_racial_background_array
                        ?.is_consent_to_the_use_of_tribal_citizenship_or_enrollment_information
                    }
                    onChange={(e) =>
                      props.formik.setFieldValue(
                        'best_group_describe_racial_background_array.is_consent_to_the_use_of_tribal_citizenship_or_enrollment_information',
                        e.target.checked
                      )
                    }
                    disabled={disabled}
                  />
                  {/* <SelectInput
                    label="Please select your primary tribal affiliation*"
                    name="best_group_describe_racial_background_array.tribal_enrollment_primary"
                    option={TribalEnrollmentPrimaryOptions1}
                    onChange={props.formik.handleChange}
                    values={
                      props.formik.values.best_group_describe_racial_background_array
                        ?.tribal_enrollment_primary
                    }
                    isMissing={
                      !props.formik.values.best_group_describe_racial_background_array
                        ?.tribal_enrollment_primary && check
                        ? true
                        : false
                    }
                  /> */}
                </>
              )}
              {/* {props.formik.values.best_group_describe_racial_background_array
                .tribal_enrollment_category === TribalEnrollmentCategoryOptions[1] && (
                <div className="my-3">
                  <SelectInput
                    label="Please select your primary tribal affiliation*"
                    name="best_group_describe_racial_background_array.tribal_enrollment_primary"
                    option={TribalEnrollmentPrimaryOptions2}
                    onChange={props.formik.handleChange}
                    values={
                      props.formik.values.best_group_describe_racial_background_array
                        ?.tribal_enrollment_primary
                    }
                    isMissing={
                      !props.formik.values.best_group_describe_racial_background_array
                        ?.tribal_enrollment_primary && check
                        ? true
                        : false
                    }
                  />
                </div>
              )} */}
              {/* {props.formik.values.best_group_describe_racial_background_array
                .tribal_enrollment_category === TribalEnrollmentCategoryOptions[2] && (
                <>
                  <SelectInput
                    label="Please select your primary tribal affiliation*"
                    name="best_group_describe_racial_background_array.tribal_enrollment_primary"
                    option={TribalEnrollmentPrimaryOptions3}
                    onChange={props.formik.handleChange}
                    values={
                      props.formik.values.best_group_describe_racial_background_array
                        ?.tribal_enrollment_primary
                    }
                    isMissing={
                      !props.formik.values.best_group_describe_racial_background_array
                        ?.tribal_enrollment_primary && check
                        ? true
                        : false
                    }
                  />
                </>
              )} */}
              {/* {props.formik.values.best_group_describe_racial_background_array
                .tribal_enrollment_category === TribalEnrollmentCategoryOptions[3] && (
                <>
                  <GroupRadioButton
                    label="Which tribe are you a member of? *"
                    logo="span-csu-logo"
                    onChange={(e: any) => {
                      let arr: any = Object.assign(
                        {},
                        props.formik.values.best_group_describe_racial_background_array
                      );
                      arr.tribe_member_of = e.target.value;
                      formik.setFieldValue(`best_group_describe_racial_background_array`, arr);
                      props.formik.handleChange(e);
                    }}
                    values={
                      props.formik.values.best_group_describe_racial_background_array
                        ?.tribe_member_of
                    }
                    options={TribeMemberOfOptions}
                    isMissing={
                      !props.formik.values.best_group_describe_racial_background_array
                        ?.tribal_enrollment_primary &&
                      !props.formik.values.best_group_describe_racial_background_array
                        ?.tribe_member_of &&
                      check
                        ? true
                        : false
                    }
                  />

                  {props.formik.values.best_group_describe_racial_background_array
                    ?.tribe_member_of === TribeMemberOfOptions[3].value && (
                    <TextInput
                      label="Please specify the Other Alaska Native Tribe: *"
                      name="best_group_describe_racial_background_array.specify_tribe_member_of_Other_Alaska_Native"
                      onChange={props.formik.handleChange}
                      values={
                        props.formik.values.best_group_describe_racial_background_array
                          ?.specify_tribe_member_of_Other_Alaska_Native
                      }
                      countText={50}
                      isMissing={
                        !props.formik.values.best_group_describe_racial_background_array
                          ?.specify_tribe_member_of_Other_Alaska_Native && check
                          ? true
                          : false
                      }
                    />
                  )}
                  {props.formik.values.best_group_describe_racial_background_array
                    ?.tribe_member_of === TribeMemberOfOptions[4].value && (
                    <TextInput
                      label="Please specify the Other American Indian Tribe: *"
                      name="best_group_describe_racial_background_array.specify_tribe_member_of_Other_American_Indian"
                      onChange={props.formik.handleChange}
                      values={
                        props.formik.values.best_group_describe_racial_background_array
                          ?.specify_tribe_member_of_Other_American_Indian
                      }
                      countText={50}
                      isMissing={
                        !props.formik.values.best_group_describe_racial_background_array
                          ?.specify_tribe_member_of_Other_American_Indian && check
                          ? true
                          : false
                      }
                    />
                  )}
                </>
              )} */}
              {/* <div className="my-3">
                <TextInput
                name="best_group_describe_racial_background_array.tribal_citizenship_or_enrollment_number"
                onChange={props.formik.handleChange}
                values={
                  props.formik.values.best_group_describe_racial_background_array
                    ?.tribal_citizenship_or_enrollment_number
                }
                label="Please provide your tribal citizenship or enrollment number."
                countText={20}
                />
              </div> */}
            </>
          )}

          {/* <TextInput
            className="my-3"
            hidden={
              props.formik.values.best_group_describe_racial_background_array
                .tribal_enrollment_category !== 'State recognized tribe (not in California)'
            }
            label="Please select your primary tribal affiliation*"
            name="best_group_describe_racial_background_array.tribal_enrollment_primary"
            onChange={props.formik.handleChange}
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.tribal_enrollment_primary
            }
          />
          <TextInput
            className="mt-3"
            hidden={
              props.formik.values.best_group_describe_racial_background_array
                .tribal_enrollment_category !== 'California non-federally recognized tribe'
            }
            label="Please select your primary tribal affiliation*"
            name="best_group_describe_racial_background_array.tribal_enrollment_primary"
            onChange={props.formik.handleChange}
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.tribal_enrollment_primary
            }
          /> */}
          <div className="mt-3"></div>
          <SelectInput
            logo="span-csu-logo"
            option={tribalEnrollmentOptions}
            label="Please choose the tribe you are enrolled in"
            className="mt-5"
            values={
              props.formik.values.best_group_describe_racial_background_array?.csu_tribe_enrolled ??
              ''
            }
            onChange={props.formik.handleChange}
            name="best_group_describe_racial_background_array.csu_tribe_enrolled"
            disabled={disabled}
          />
        </Card>
      )}
      {/* If Asian then show following content */}
      {props.formik.values.best_group_describe_racial_background_array
        ?.racial_background_identify_Asian && (
        <Card className="my-3 bg-white p-3">
          <GroupRadioButton
            label="Which best describes your Asian background?"
            logo="span-csu-logo"
            name={'best_group_describe_racial_background_array.value_is_Asian'}
            values={props.formik.values.best_group_describe_racial_background_array?.value_is_Asian}
            onChange={props.formik.handleChange}
            disabled={disabled}
            options={asianOptions}
            columns={4}
            isMissing={
              !props.formik.values.best_group_describe_racial_background_array?.value_is_Asian &&
              check
                ? true
                : false
            }
          />

          {props.formik.values.best_group_describe_racial_background_array
            ?.value_is_Asian === 'Other Asian' && (
            <TextInput
              className="px-3"
              label="Specify other Asian background*"
              mdCol="12"
              name="best_group_describe_racial_background_array.racial_OtherAsian_value"
              values={
                props.formik.values.best_group_describe_racial_background_array
                  ?.racial_OtherAsian_value
              }
              isMissing={
                !props.formik.values.best_group_describe_racial_background_array
                  ?.racial_OtherAsian_value && check
                  ? true
                  : false
              }
              onChange={props.formik.handleChange}
              disabled={disabled}
              countText={50}
            />
          )}
        </Card>
      )}

      {/* If Black or African American is selected */}
      {props.formik.values.best_group_describe_racial_background_array
        ?.racial_background_identify_AfricanAmerican && (
        <Card className="my-3 bg-white p-3">
          <GroupRadioButton
            onChange={props.formik.handleChange}
            options={[
              { label: 'African', value: 'African' },
              { label: 'U.S. / African American', value: 'U.S. / African American' },
              { label: 'Caribbean', value: 'Caribbean' },
              { label: 'Other', value: 'Other' },
            ]}
            logo="span-csu-logo"
            label="What best describes your Black or African American background?*"
            columns={2}
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.racial_background_African
            }
            name="best_group_describe_racial_background_array.racial_background_African"
            disabled={disabled}
            isMissing={
              !props.formik.values.best_group_describe_racial_background_array
                ?.racial_background_African && check
                ? true
                : false
            }
          />
          {props.formik.values.best_group_describe_racial_background_array
            ?.racial_background_African === 'Other' && (
            <TextInput
              className="px-3"
              label="Describe other*"
              mdCol="12"
              name="best_group_describe_racial_background_array.racial_OtherAfrican_value"
              values={
                props.formik.values.best_group_describe_racial_background_array
                  ?.racial_OtherAfrican_value
              }
              isMissing={
                !props.formik.values.best_group_describe_racial_background_array
                  ?.racial_OtherAfrican_value && check
                  ? true
                  : false
              }
              onChange={props.formik.handleChange}
              disabled={disabled}
              countText={50}
            />
          )}
        </Card>
      )}
      {/* If Native Hawaiian or Other Pacific Islander is seleted */}
      {props.formik.values.best_group_describe_racial_background_array
        ?.racial_background_identify_NativeHawaiian && (
        <Card className="my-3 bg-white p-3">
          <GroupRadioButton
            label="Which best describes your Native Hawaiian or Other Pacific Islander background?*"
            logo="span-csu-logo"
            name={
              'best_group_describe_racial_background_array.value_is_Native_Hawaiian_or_Other_Pacific_Islander'
            }
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.value_is_Native_Hawaiian_or_Other_Pacific_Islander
            }
            onChange={props.formik.handleChange}
            disabled={disabled}
            options={nativeHawaiianOptions.map((i) => i.label)}
            columns={4}
            isMissing={
              !props.formik.values.best_group_describe_racial_background_array
                ?.value_is_Native_Hawaiian_or_Other_Pacific_Islander && check
            }
          />
          {(
            props.formik.values.best_group_describe_racial_background_array
              ?.value_is_Native_Hawaiian_or_Other_Pacific_Islander ?? ''
          )?.includes('Other') && (
            <TextInput
              className="px-3"
              label="Please Specify Your Other Background*"
              mdCol="12"
              name="best_group_describe_racial_background_array.racial_OtherPacific_value"
              values={
                props.formik.values.best_group_describe_racial_background_array
                  ?.racial_OtherPacific_value
              }
              onChange={props.formik.handleChange}
              disabled={disabled}
              countText={100}
              isMissing={
                !props.formik.values.best_group_describe_racial_background_array
                  ?.racial_OtherPacific_value && check
                  ? true
                  : false
              }
            />
          )}
        </Card>
      )}
      {/* If White is selected */}
      {props.formik.values.best_group_describe_racial_background_array
        ?.racial_background_identify_White && (
        <Card className="my-3 bg-white p-3">
          <GroupRadioButton
            justifyContent="flex-between"
            options={swAsianAndNorthAfricanOptions.map((option) => option.value)}
            logo="span-csu-logo"
            label="Which best describes your White background?*"
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.racial_background_White
            }
            onChange={props.formik.handleChange}
            name="best_group_describe_racial_background_array.racial_background_White"
            disabled={disabled}
            isMissing={
              !props.formik.values.best_group_describe_racial_background_array
                ?.racial_background_White && check
                ? true
                : false
            }
          />

          {props.formik.values.best_group_describe_racial_background_array
            ?.racial_background_White === 'Other White' && (
            <TextInput
              className="px-3"
              label="Please Specify Your Other Background*"
              mdCol="12"
              name="best_group_describe_racial_background_array.racial_OtherWhite_value"
              isMissing={
                !props.formik.values.best_group_describe_racial_background_array
                  ?.racial_OtherWhite_value && check
                  ? true
                  : false
              }
              values={
                props.formik.values.best_group_describe_racial_background_array
                  ?.racial_OtherWhite_value
              }
              onChange={props.formik.handleChange}
              disabled={disabled}
              countText={50}
            />
          )}
        </Card>
      )}
      {/* If _Southwest_Asian_and_North_African is selected */}
      {props.formik.values.best_group_describe_racial_background_array
        ?.racial_background_identify_Southwest_Asian_and_North_African && (
        <Card className="my-3 bg-white p-3">
          <GroupRadioButton
            columns={4}
            options={[
              'Afghan',
              'Algerian',
              'Amazigh',
              'Armenian',
              'Assyrian / Chaldean',
              'Azerbaijani',
              'Bahraini',
              'Circassian',
              'Cypriot',
              'Djiboutian',
              'Egyptian',
              'Emirati',
              'Georgian',
              'Iranian',
              'Iraqi',
              'Israeli',
              'Jordanian',
              'Kurdish',
              'Kuwaiti',
              'Lebanese',
              'Libyan',
              'Mauritanian',
              'Moroccan',
              'Omani',
              'Palestinian',
              'Pontic Greek',
              'Qatari',
              'Saudi Arabian',
              'Sudanese',
              'Syrian',
              'Tunisian',
              'Turkish',
              'Uzbek',
              'Yemeni',
              'Other Southwest Asian',
              'Other North African',
            ]}
            label="Which best describes your Southwest Asian or North African background?*"
            mdCol={4}
            name="best_group_describe_racial_background_array.racial_Southwest_Asian_and_North_African"
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.racial_Southwest_Asian_and_North_African
            }
            logo="span-csu-logo"
            onChange={props.formik.handleChange}
            disabled={disabled}
            isMissing={
              !props.formik.values.best_group_describe_racial_background_array
                ?.racial_Southwest_Asian_and_North_African && check
                ? true
                : false
            }
          />
          <TextInput
            className="px-3"
            hidden={
              !(
                props.formik.values.best_group_describe_racial_background_array
                  ?.racial_Southwest_Asian_and_North_African ?? ''
              ).includes('Other')
            }
            label="Please Specify:"
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.racial_Southwest_Asian_and_North_African_other
            }
            name="best_group_describe_racial_background_array.racial_Southwest_Asian_and_North_African_other"
            onChange={props.formik.handleChange}
            disabled={disabled}
            isMissing={
              !props.formik.values.best_group_describe_racial_background_array
                ?.racial_Southwest_Asian_and_North_African_other && check
                ? true
                : false
            }
          />
        </Card>
      )}

      <Col xs={12} className="common-flag">
        <Card
          className="my-3 p-4 position-relative"
          style={{ backgroundColor: '#AAEBF7', borderColor: '#AAEBF7' }}
        >
          <SelectInput
            mdCol="12"
            option={[
              'Select',
              'American Indian or Alaska Native',
              'Asian',
              'Black or African American',
              'Hispanic or Latino',
              'Native Hawaiian or other Pacific Islander',
              'White',
              'Two or more races/ethnicities',
              'Decline to state',
            ]}
            logo="span-csu-logo"
            isLongLableText={true}
            name={'best_group_describe_racial_background_array.csu_reporting_preferences'}
            isMissing={
              !props.formik.values.best_group_describe_racial_background_array
                ?.csu_reporting_preferences && check
                ? true
                : false
            }
            values={
              props.formik.values.best_group_describe_racial_background_array
                ?.csu_reporting_preferences
            }
            onChange={props.formik.handleChange}
            disabled={disabled}
            label="California State University often needs to report ONLY ONE summary race/ethnicity description for a person. Please select your reporting preferences:*"
          />
          <div
            className="gm-card-blue-content my-2"
            style={{
              display: 'inline-block',
              background: (!props.formik.values.is_complete_satisfaction && check ? true : false)
                ? '#FFEBEB'
                : '',
            }}
          >
            The questions in this section, while helpful to colleges, are entirely optional, and
            you're welcome to move on without answering them. Before you do, please confirm for us
            that you've completed this section to your satisfaction.*
          </div>
          <CheckboxInput
            label={
              <span className="ms-1 text-primary">
                Yes, I have completed this section to my satisfaction.
              </span>
            }
            name={'is_complete_satisfaction'}
            values={props.formik.values.is_complete_satisfaction}
            onChange={props.formik.handleChange}
            disabled={disabled}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default Ethnicity;
